var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepNavigationFoundingTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1637_2326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6813 52.1067H42.2125C44.7379 52.1067 46.7922 50.0524 46.7922 47.527V15.2656H36.1063C33.5809 15.2656 31.5266 13.2113 31.5266 10.6859V0H11.6813C9.15591 0 7.10156 2.05435 7.10156 4.57969V47.527C7.10156 50.0524 9.15591 52.1067 11.6813 52.1067ZM17.7875 21.4737H36.1063C36.9501 21.4737 37.6328 22.1564 37.6328 23.0002C37.6328 23.844 36.9501 24.5268 36.1063 24.5268H17.7875C16.9437 24.5268 16.2609 23.844 16.2609 23.0002C16.2609 22.1564 16.9437 21.4737 17.7875 21.4737ZM17.7875 27.5799H36.1063C36.9501 27.5799 37.6328 28.2627 37.6328 29.1065C37.6328 29.9503 36.9501 30.633 36.1063 30.633H17.7875C16.9437 30.633 16.2609 29.9503 16.2609 29.1065C16.2609 28.2627 16.9437 27.5799 17.7875 27.5799ZM17.7875 33.6862H36.1063C36.9501 33.6862 37.6328 34.369 37.6328 35.2127C37.6328 36.0565 36.9501 36.7393 36.1063 36.7393H17.7875C16.9437 36.7393 16.2609 36.0565 16.2609 35.2127C16.2609 34.369 16.9437 33.6862 17.7875 33.6862ZM17.7875 39.7924H30C30.8438 39.7924 31.5266 40.4752 31.5266 41.319C31.5266 42.1628 30.8438 42.8456 30 42.8456H17.7875C16.9437 42.8456 16.2609 42.1628 16.2609 41.319C16.2609 40.4752 16.9437 39.7924 17.7875 39.7924Z",
    fill: "url(#paint0_linear_1637_2326)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1047 12.2087H45.8962L34.5781 0.890625V10.6821C34.5781 11.5244 35.2624 12.2087 36.1047 12.2087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1047 12.2087H45.8962L34.5781 0.890625V10.6821C34.5781 11.5244 35.2624 12.2087 36.1047 12.2087Z",
    fill: "url(#paint1_linear_1637_2326)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1637_2326",
    x1: 26.9469,
    y1: 0,
    x2: 26.9469,
    y2: 52.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1637_2326",
    x1: 40.2371,
    y1: 0.890625,
    x2: 40.2371,
    y2: 12.2087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1637_2326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1067,
    height: 52.1067,
    fill: "white",
    transform: "translate(0.894531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepNavigationFoundingTeam);
export default __webpack_public_path__ + "static/media/stepNavigationFoundingTeam.f34606602ce41a856ae50fe5a9c08c58.svg";
export { ForwardRef as ReactComponent };